import styled from 'styled-components'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const HeaderWrapper = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
`

export const PlanName = styled.span`
  font-size: 15px;
  color: #B2B2B2;
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FieldLabel = styled.span`
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
`

export const FieldValue = styled.span<{ $color?: string }>`
  font-size: 15px;
  font-weight: 400;
  line-height: 1.4;
  white-space: pre-line;
  color: ${({ $color }) => $color ?? 'inherit'};
`

export const StateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 200px;
  padding: 24px;
  text-align: center;
`

export const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 24px;

  button {
    width: 100%;
    border-radius: 50px;
  }
`
